export default "__VITE_ASSET__7908cf34__"